import React from 'react'

export const LoginPage = React.lazy(() => import('./LoginPage'))
export const UsersListPage = React.lazy(() => import('./UsersListPage'))
export const ReportedPicsPage = React.lazy(() => import('./ReportedPicsPage'))
export const ReportedUsersPage = React.lazy(() => import('./ReportedUsersPage'))
export const ReportedCommentsPage = React.lazy(() => import('./ReportedCommentsPage'))
export const TransactionsPage = React.lazy(() => import('./TransactionPage'))
export const SettingsPage = React.lazy(() => import('./SettingsPage'))
